<template>
  <div class="px-10">
    <v-toolbar dense flat :class="tab === 1 ? 'mb-3' : 'mb-10'">
      <div class="text-h4 primary--text">ติดตามงานต่อภาษี</div>
      
      <div style="width: 300px">
        <v-text-field
          class="ml-2"
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="ค้นหา เลขทะเบียน ชื่อลูกค้า"
          outlined
          rounded
          dense
          single-line
          hide-details
        ></v-text-field>
      </div>
      <v-spacer></v-spacer>
      <!-- <v-text-field label="วันที่" prepend-inner-icon="mdi-calendar" outlined rounded dense hide-details></v-text-field> -->
      <template v-if="tab === 1">
        <div class="" v-if="totalTax">
          ยอดรวมภาษี {{ totalTax | numeral('0,0') }} บาท
        </div>
        <v-spacer></v-spacer>
        <div style="width: 200px">
          <v-select
            label="รอบ"
            v-model="taxRenewalRound"
            @change="onRoundSelected"
            :items="renewalTaxList"
            item-value="value"
            item-text="text"
            outlined
            rounded
            dense
            hide-details
          />
        </div>
      </template>

    </v-toolbar>
    <!-- in-progress tab: the summary downloads work on the chosen round, so they sit on their own line -->
    <div
      v-if="tab === 1"
      class="d-flex align-center flex-wrap justify-end mb-6"
      data-test="download-row"
    >
      <span
        v-if="!roundSelected"
        class="mr-4 orange--text text--darken-2"
        data-test="download-hint"
      >
        <v-icon small color="orange darken-2" class="mb-1">mdi-information-outline</v-icon>
        เลือกรอบก่อน จึงจะดาวน์โหลดได้
      </span>
      <v-btn
        color="primary"
        small
        @click="printTax()"
        :disabled="!roundSelected"
      >
        ดาวน์โหลดใบรวมภาษี <v-icon right>mdi-printer</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        outlined
        small
        class="ml-2"
        data-test="download-split"
        @click="printTax(true)"
        :disabled="!roundSelected"
      >
        ดาวน์โหลด Excel แยกประเภทรถ <v-icon right>mdi-microsoft-excel</v-icon>
      </v-btn>
    </div>
    <v-card outlined class="mb-5"
      ><v-card-text>
        <v-row class="my-1">
          <template>
            <!-- <v-text-field label="วันที่" prepend-inner-icon="mdi-calendar" outlined rounded dense hide-details></v-text-field> -->
            <div style="width: 300px" class="ml-2 my-1">
              <v-select
                label="กรอกจากวัน"
                v-model="date_type"
                :items="[
                  { text: 'วันสร้างบิล', value: 0 },
                  { text: 'วันที่จะยื่นต่อภาษี', value: 1 },
                ]"
                item-value="value"
                item-text="text"
                outlined
                rounded
                dense
                hide-details
              />
            </div>
            <div style="width: 200px" class="ml-2 my-1">
              <DatePicker
                label="วันเริ่มต้น"
                :value="startDate"
                @onChange="
                  (val) => {
                    startDate = val;
                  }
                "
                hideDetails
                outlined
                rounded
                dense
              />
            </div>
            <div style="width: 200px" class="ml-1 my-1">
              <DatePicker
                label="วันสิ้นสุด"
                :value="endDate"
                @onChange="
                  (val) => {
                    endDate = val;
                  }
                "
                hideDetails
                outlined
                rounded
                dense
              />
            </div>
            <div style="width: 300px" class="ml-2 my-1">
              <v-select
                label="ประเภทรถ"
                v-model="carTypeId"
                :items="[
                  { text: 'ทั้งหมด', value: 0 },
                  { text: 'รถยนต์', value: 1 },
                  { text: 'รถจักรยานยนต์', value: 2 },
                  { text: 'อื่น ๆ', value: 3 },
                ]"
                item-value="value"
                item-text="text"
                outlined
                rounded
                dense
                hide-details
              />
            </div>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- notices for the list below: they stay outside (above) the table card -->
    <v-alert
      v-if="searchOtherTabsText"
      type="info"
      text
      dense
      class="mb-3"
      data-test="search-other-tabs"
    >
      {{ searchOtherTabsText }}
    </v-alert>
    <!-- what is selected and what can be done with it, on one line above the table card -->
    <div
      v-if="tab !== 3"
      class="d-flex align-center flex-wrap rounded px-4 py-2 mb-3"
      :style="{ background: selectedCount ? '#E3F2FD' : '#F5F5F5' }"
      data-test="action-bar"
    >
      <v-btn
        small
        outlined
        color="primary"
        class="white mr-3"
        :loading="selectingAll"
        data-test="select-all"
        @click="selectAll"
      >
        เลือกทั้งหมด (ตามช่วงวันที่)
      </v-btn>
      <v-btn
        v-if="selectedCount"
        small
        outlined
        color="#424242"
        class="white mr-3"
        data-test="clear-selection"
        @click="clearSelection"
      >
        ล้างที่เลือก
      </v-btn>
      <v-spacer />
      <span v-if="selectedCount" class="primary--text mr-4" data-test="selected-count">
        เลือกไว้แล้ว {{ selectedCount }} คัน (รวมทุกหน้า)
        <span v-if="selectAllTruncated" data-test="select-all-limit">
          — เลือกได้สูงสุด {{ selectAllMax.toLocaleString() }} คัน ยังมีรายการที่ตรงตัวกรองอีก
        </span>
      </span>
      <span v-else class="grey--text text--darken-1 mr-4">ยังไม่ได้เลือกรายการ</span>
      <template v-if="tab === 0">
        <v-btn
          color="error"
          outlined
          small
          @click="cancelPendingProcess()"
          :disabled="!selectedCount"
        >
          ยกเลิก
        </v-btn>
        <v-btn
          color="success"
          small
          class="ml-2"
          @click="openDialogPending()"
          :disabled="!selectedCount"
        >
          ส่งต่อภาษี
        </v-btn>
      </template>
      <template v-else-if="tab === 1">
        <v-btn
          color="error"
          outlined
          small
          @click="cancelInprogressProcess()"
          :disabled="!selectedCount"
        >
          ยกเลิก
        </v-btn>
        <v-btn
          color="success"
          small
          class="ml-2"
          @click="PayTax()"
          :disabled="!selectedCount"
        >
          จ่ายค่าภาษี
        </v-btn>
      </template>
      <template v-else-if="tab === 2">
        <v-btn
          color="success"
          small
          @click="getBook()"
          :disabled="!selectedCount"
        >
          ลูกค้ารับเล่มแล้ว
        </v-btn>
        <v-btn
          color="error"
          outlined
          small
          class="ml-2"
          @click="cancelCompleteProcess()"
          :disabled="!selectedCount"
        >
          ยกเลิก
        </v-btn>
      </template>
      <template v-else-if="tab === 4">
        <v-btn
          color="primary"
          small
          @click="backToPending()"
          :disabled="!selectedCount"
        >
          กลับไปรอดำเนินงาน
        </v-btn>
      </template>
    </div>
    <v-card>
      <v-tabs
        v-model="tab"
        align-with-title
        background-color="white"
        active-class="light black--text"
      >
        <v-tabs-slider color="light"></v-tabs-slider>
        <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <Pending
            ref="pending"
            :key="'pending_' + tab"
            @on-selected="selected.pending = $event"
            :search="appliedSearch"
            :start-date="startDate"
            :end-date="endDate"
            :date_type="date_type"
            :car-type-id="carTypeId"
            :active="tab === 0"
            :update-list="updatePending"
            @reloadParent="reloadPending"
          />
        </v-tab-item>
        <v-tab-item>
          <InProgress
            ref="inprogress"
            :start-date="startDate"
            :end-date="endDate"
            :date_type="date_type"
            :car-type-id="carTypeId"
            :active="tab === 1"
            :key="'inprogress_' + tab"
            v-model="totalTax"
            @on-selected="selected.inprogress = $event"
            :search="appliedSearch"
            :tax-renewal-round="taxRenewalRound"
            :update-list="updateInprogress"
          />
        </v-tab-item>
        <v-tab-item>
          <Complete
            ref="complete"
            :start-date="startDate"
            :end-date="endDate"
            :date_type="date_type"
            :car-type-id="carTypeId"
            :active="tab === 2"
            :key="'complete_' + tab"
            @on-selected="selected.complete = $event"
            :search="appliedSearch"
          />
        </v-tab-item>
        <v-tab-item>
          <Received
            ref="receive"
            :start-date="startDate"
            :end-date="endDate"
            :date_type="date_type"
            :car-type-id="carTypeId"
            :active="tab === 3"
            :key="'receive_' + tab"
            @on-selected="selected.received = $event"
            :search="appliedSearch"
          />
        </v-tab-item>
        <v-tab-item>
          <Cancel
            ref="cancel"
            :start-date="startDate"
            :end-date="endDate"
            :date_type="date_type"
            :car-type-id="carTypeId"
            :active="tab === 4"
            :key="'cancel_' + tab"
            @on-selected="selected.cancel = $event"
            :search="appliedSearch"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog persistent scrollable max-width="600" v-model="dialogPendingForm">
      <PendingForm
        ref="pendingForm"
        :item="dialogPendingFormData"
        :process-array="dialogPendingFormProcessArray"
        @onClose="closeDialogPending"
        @onSave="onSaveDialogPending"
        @reloadParent="reloadPending"
      />
    </v-dialog>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue';
import Pending from './Pending';
import InProgress from './InProgress';
import Complete from './Complete';
import Received from './Received';
import Cancel from './Cancel';
import PendingForm from './PendingForm';
import { SELECT_ALL_MAX } from './listFilterMixin';
import * as moment from 'moment';

// per tab (same order as `items`): key in `selected` and ref name of the tab component
const SELECTED_KEYS = ['pending', 'inprogress', 'complete', 'received', 'cancel'];
const SELECTED_REFS = ['pending', 'inprogress', 'complete', 'receive', 'cancel'];

export default {
  components: {
    DatePicker,
    Pending,
    InProgress,
    Complete,
    Received,
    Cancel,
    PendingForm,
  },
  data: () => ({
    loading: false,
    dialogPendingForm: false,
    dialogPendingFormData: null,
    dialogPendingFormProcessArray: [],

    renewalTaxList: [],
    renewalRanges: {},
    roundAutoFilter: null,
    carTypeId: 0,
    date_type: 0,
    taxRenewalRound: '',
    startDate: moment().add(-3, 'months').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),

    search: '',
    appliedSearch: '',
    searchOtherTabs: [],
    selectingAll: false,
    selectAllTruncated: false,
    selectAllMax: SELECT_ALL_MAX,
    searchJump: false,
    searchToken: 0,
    tab: 0,
    items: [
      'รอดำเนินการ',
      'กำลังดำเนินการ',
      'งานเสร็จสมบูรณ์ (รอลูกค้ามารับ)',
      'ลูกค้ารับไปแล้ว',
      'ยกเลิก',
    ],

    selected: {
      pending: [],
      inprogress: [],
      complete: [],
      received: [],
      cancel: [],
    },

    totalTax: null,
    updatePending: 0,
    updateInprogress: 0,
    updateComplete: 0,
    updateCancel: 0,
  }),
  computed: {
    // the summary downloads need a round (the "all rounds" entry has no value)
    roundSelected() {
      return !(this.taxRenewalRound == '' || this.taxRenewalRound == 0);
    },
    // rows ticked in the current tab, kept while paging (the buttons act on all of them)
    selectedCount() {
      return (this.selected[SELECTED_KEYS[this.tab]] || []).length;
    },
    // shown above the table when the searched car is also in other tabs
    searchOtherTabsText() {
      if (!this.searchOtherTabs.length) return '';
      const parts = this.searchOtherTabs.map(
        (x) => `"${this.items[x.tab]}" อีก ${x.count} คัน`
      );
      return `เจอรถคันนี้อยู่แท็บ ${parts.join(', ')}`;
    },
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  created() {
    this.tab = Number(this.$route.params.tab) || 0;
    this.$router.replace({ name: 'follow-tax' }).catch(() => {});
  },
  methods: {
    // Select every row that matches the filters (date range, car type, search, round), on every page
    async selectAll() {
      const ref = this.$refs[SELECTED_REFS[this.tab]];
      if (this.selectingAll || !ref || !ref.selectAllMatching) return;
      this.selectingAll = true;
      try {
        const { truncated } = await ref.selectAllMatching();
        this.selectAllTruncated = truncated;
      } catch (err) {
        console.log('err', err);
        this.$alertServerError({
          title: (err && err.error_message) || 'เลือกทั้งหมดไม่สำเร็จ กรุณาลองใหม่',
        });
      }
      this.selectingAll = false;
    },
    clearSelection() {
      this.selectAllTruncated = false;
      const ref = this.$refs[SELECTED_REFS[this.tab]];
      if (ref) ref.selected = [];
      this.selected[SELECTED_KEYS[this.tab]] = [];
    },
    // Debounced search: ask the backend which tabs contain the car, jump to the
    // first of them, and apply the text to the lists.
    async applySearch() {
      const text = this.search.trim();
      const token = ++this.searchToken;
      if (!text) {
        this.appliedSearch = '';
        this.searchOtherTabs = [];
        return;
      }
      let counts = {};
      try {
        counts = await this.getSearchTabCounts(text);
      } catch (err) {
        console.log('err', err); // fall back to searching the current tab only
      }
      if (token !== this.searchToken) return; // a newer search / tab click won
      const found = this.items
        .map((name, tab) => ({ tab, count: counts[tab] || 0 }))
        .filter((x) => x.count > 0);
      this.searchOtherTabs = found.slice(1);
      if (found.length && found[0].tab !== this.tab) {
        this.searchJump = true;
        this.tab = found[0].tab;
      }
      this.appliedSearch = text;
    },
    async getSearchTabCounts(text) {
      const payload = {
        branch_id: this.$store.state.selected_branch._id,
        tracking_type: 0,
        start_with: text,
        start_date: this.startDate,
        end_date: this.endDate,
        date_type: this.date_type,
        car_type_filter: this.carTypeId,
      };
      const body = {
        token: this.$jwt.sign(payload, this.$privateKey, { noTimestamp: true }),
      };
      const res = await this.$axios.post(
        `${this.$baseUrl}/process/get_search_tab_counts`,
        body
      );
      return res.result || {};
    },
    reloadPending() {
      this.$refs.pending.reloadComponent();
    },
    async openDialogPending() {
      this.loading = true;
      this.dialogPendingForm = true;
      this.dialogPendingFormProcessArray = this.$refs.pending.selected.map(
        (x) => x._id
      );
      this.dialogPendingFormData = await this.renewalTax(
        this.dialogPendingFormProcessArray
      );
      if (!this.dialogPendingFormData) {
        this.dialogPendingForm = false;
      }
      this.loading = false;
    },
    closeDialogPending() {
      this.dialogPendingForm = false;
    },
    onSaveDialogPending() {
      this.updatePending++;
      this.selected.pending = [];
      this.$refs.pending.selected = [];
    },
    async renewalTax(processArray) {
      let payload = {
        branch_id: this.$store.state.selected_branch._id,
        process_array: processArray,
      };
      let body = {
        token: this.$jwt.sign(payload, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      try {
        const res = await this.$axios.post(
          `${this.$baseUrl}/process/renewal_tax`,
          body
        );
        return res.result;
      } catch (err) {
        console.log('err', err);
        this.$alertServerError({ title: err.error_message });
        return null;
      }
    },

    async getRenewalTaxList() {
      let payload = {
        branch_id: this.$store.state.selected_branch._id,
        with_range: true,
      };
      let body = {
        token: this.$jwt.sign(payload, this.$privateKey, { noTimestamp: true }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/renewal_tax_list`, body)
        .then((res) => {
          const rounds =
            res.result && typeof res.result === 'object' ? res.result : [];
          const list = [{ text: 'ทั้งหมด', value: '' }];
          const ranges = {};
          const sorted = [...rounds].sort(
            (a, b) =>
              this.roundSortKey(typeof b === 'string' ? b : b.tax_round) -
              this.roundSortKey(typeof a === 'string' ? a : a.tax_round)
          );
          for (const round of sorted) {
            // items are {tax_round, min_date, ...}; a plain string is the
            // legacy shape (no date range known for that round)
            const name = typeof round === 'string' ? round : round.tax_round;
            if (typeof round !== 'string') ranges[name] = round;
            list.push({ value: name, text: name });
          }
          this.renewalTaxList = list;
          this.renewalRanges = ranges;
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
    },
    // Round names look like "ddmmyyyy / รอบ n" (Buddhist year). Newest first means
    // sorting by that date, then by the round number; names that don't parse go last.
    roundSortKey(name) {
      const m = /^(\d{2})(\d{2})(\d{4})\s*\/\s*รอบ\s*(\d+)/.exec(name || '');
      if (!m) return -1;
      const [, day, month, year, no] = m;
      return (
        (Number(year) * 10000 + Number(month) * 100 + Number(day)) * 1000 +
        Math.min(Number(no), 999)
      );
    },
    // Choosing a round widens the date range (never narrows it) and resets the
    // car type so the in-progress jobs of that round are not filtered out.
    onRoundSelected(round) {
      if (!round) return this.restoreRoundFilter();
      const range = this.renewalRanges[round];
      if (!range) return;
      const byTaxDate = this.date_type === 1;
      const min = byTaxDate ? range.min_tax_filling_date : range.min_date;
      const max = byTaxDate ? range.max_tax_filling_date : range.max_date;
      if (!this.roundAutoFilter) {
        this.roundAutoFilter = {
          before: {
            startDate: this.startDate,
            endDate: this.endDate,
            carTypeId: this.carTypeId,
          },
        };
      }
      if (min && min < this.startDate) this.startDate = min;
      if (max && max > this.endDate) this.endDate = max;
      this.carTypeId = 0;
      this.roundAutoFilter.applied = {
        startDate: this.startDate,
        endDate: this.endDate,
        carTypeId: this.carTypeId,
      };
    },
    // Undo the automatic change, unless the user has edited the filters since.
    restoreRoundFilter() {
      const auto = this.roundAutoFilter;
      this.roundAutoFilter = null;
      if (!auto || !auto.applied) return;
      const now = {
        startDate: this.startDate,
        endDate: this.endDate,
        carTypeId: this.carTypeId,
      };
      if (JSON.stringify(now) !== JSON.stringify(auto.applied)) return;
      this.startDate = auto.before.startDate;
      this.endDate = auto.before.endDate;
      this.carTypeId = auto.before.carTypeId;
    },
    PayTax() {
      let process_array = this.$refs.inprogress.selected.map((x) => {
        return {
          process_id: x._id,
          transportation_fee: x.tax_data.transportation_fee,
        };
      });
      this.$router
        .push({
          name: 'follow-tax-paytax',
          params: { process_array: process_array },
        })
        .catch(() => {});
    },
    // splitByVehicle: one table per vehicle group (car / motorcycle / truck) in the same sheet
    async printTax(splitByVehicle = false) {
      this.loading = true;
      let payload = {
        branch_id: this.$store.state.selected_branch._id,
        tax_renewal_round: this.taxRenewalRound,
      };
      if (splitByVehicle) payload.split_by_vehicle_type = true;
      let body = {
        token: this.$jwt.sign(payload, this.$privateKey, { noTimestamp: true }),
      };
      await this.$axios({
        method: 'post',
        url: `${this.$baseUrl}/process/download_car_renewal_tax_summary`,
        responseType: 'blob',
        data: body,
      })
        .then((response) => {
          this.forceFileDownload(
            response,
            'ใบรวมภาษี-' + (splitByVehicle ? 'แยกประเภทรถ-' : '') + this.taxRenewalRound + '.xlsx'
          );
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
      this.loading = false;
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    async handleCancelProcess(selectedItems, refName) {
      try {
        const cancelArray = selectedItems.map(item => item.car_plate);
        const processArray = selectedItems.map(item => item._id);
        const result = await this.$alertConfirm({
          title: `ยกเลิก ${cancelArray.length} คัน`,
          html: `<h4>${cancelArray.join(', ')}</h4>`,
        });

        if (result.isConfirmed) {
          const body = {
            token: this.$jwt.sign(
              { process_array: processArray },
              this.$privateKey,
              { noTimestamp: true }
            ),
          };

          await this.$axios.post(`${this.$baseUrl}/process/cancel_process`, body);

          // Reset selections and update the UI
          const ref = this.$refs[refName];
          if (ref) ref.selected = [];
          this.selected[refName] = [];
          this[`update${refName.charAt(0).toUpperCase() + refName.slice(1)}`]++;
          this.tab = 4;

        }
      } catch (err) {
        this.$captureException(err, {
          source: 'follow.tax.cancelProcess',
          process: refName
        });
        this.$alertServerError({
          title: (err && err.error_message) || 'ยกเลิกไม่สำเร็จ กรุณาลองใหม่',
        });
      }
    },

    // Usage for In-progress Process
    async cancelInprogressProcess() {
      await this.handleCancelProcess(this.$refs.inprogress.selected, 'inprogress');
    },

    // Usage for Pending Process
    async cancelPendingProcess() {
      await this.handleCancelProcess(this.$refs.pending.selected, 'pending');
    },

     // Usage for In-progress Process
     async cancelCompleteProcess() {
      await this.handleCancelProcess(this.$refs.complete.selected, 'complete');
    },
  
    async getBook() {
      this.$alertConfirm({ title: `ยืนยันลูกค้ามารับเล่ม ?`, text: `` }).then(
        async (result) => {
          if (result.isConfirmed) {
            let process_array = this.$refs.complete.selected.map((x) => {
              return x._id;
            });
            let body = {
              token: this.$jwt.sign(
                { process_id: process_array },
                this.$privateKey,
                { noTimestamp: true }
              ),
            };
            await this.$axios
              .post(`${this.$baseUrl}/process/record_tax_parcel_book`, body)
              .then((res) => {
                this.selected.complete = [];
                this.$refs.complete.selected = [];
                this.tab = 3;
              })
              .catch((err) => {
                console.log('err', err);
                this.$alertServerError({ title: err.error_message });
              });
            this.updateComplete++;
          }
        }
      );
    },
    async backToPending() {
      try {
        // Confirm action with the user
        const resetArray = this.$refs.cancel.selected.map(item => item.car_plate);
        const result = await this.$alertConfirm({
          title: `ย้ายกลับไป รอดำเนินการ ${resetArray.length} คัน`,
          html: `<h4>${resetArray.join(', ')}</h4>`,
        });

        if (result.isConfirmed) {
          // Map selected items to extract process IDs
          const processArray = this.$refs.cancel.selected.map(item => item._id);

          // Create the request body with a signed token
          const body = {
            token: this.$jwt.sign(
              { process_array: processArray },
              this.$privateKey,
              { noTimestamp: true }
            ),
          };

          // Send the request to reset the process
          await this.$axios.post(`${this.$baseUrl}/process/reset_process`, body);

          // Clear selected items and update the UI
          this.selected.cancel = [];
          this.tab = 0;
          this.updateCancel++;

          // Reset the selected items in the cancel list
          this.$refs.cancel.selected = [];
        }
      } catch (err) {
        this.$captureException(err, {
          source: 'follow.tax.resetProcessToPending'
        });
        this.$alertServerError({ title: err.error_message });
      }
    },
  },
  watch: {
    search(newVal) {
      clearTimeout(this.searchTimer);
      if (!newVal.trim()) return this.applySearch();
      this.searchTimer = setTimeout(this.applySearch, 500);
    },
    tab: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        // every tab component is rebuilt on a tab change, so nothing stays ticked
        this.selected = { pending: [], inprogress: [], complete: [], received: [], cancel: [] };
        this.selectAllTruncated = false;
        if (this.searchJump) {
          this.searchJump = false; // moved here by the search: keep the text
        } else {
          this.search = '';
          this.appliedSearch = '';
          this.searchOtherTabs = [];
          this.searchToken++;
        }
        this.taxRenewalRound = '';
        this.restoreRoundFilter();
        // the round list only matters on the in-progress tab; reload it on
        // every visit so rounds without in-progress jobs disappear
        if (newVal === 1) this.getRenewalTaxList();
      }
    },
  },
};
</script>
